module.exports = __webpack_public_path__ + "img/Loose Clasp.8db95b5b.png";